import ObjectID from 'bson-objectid';
import Hashids from './hashids';

const hashids = new Hashids();

export class IdGenerator {

    static generate(prefix: string) {
        let objId = new ObjectID();
        let hex = objId.toHexString();
        let hex1 = hex.substr(0,12);
        let hex2 = hex.substring(12);
        let number1: number = parseInt(hex1, 16);
        let number2: number = parseInt(hex2, 16);
        
        return `${prefix}-${hashids.encode(number1, number2)}`;
    }
}